import React, { useEffect, useState } from 'react';
import zenscroll from 'zenscroll';

const ref = React.createRef();

const PageNavigation = props => {
  const { anchors, activeClass } = props;
  const [highlightedIndex, setHighlightedIndex] = useState(0);

  useEffect(() => {
    const childNodes = Array.prototype.slice.call(ref.current.getElementsByTagName('a'));

    const containers = childNodes.map(node => {
      if (node.hash) {
        const target = document.getElementById(node.hash.substr(1));
        if (target) {
          return target;
        }
      }
    });

    const defaultDuration = 300; // ms
    const edgeOffset = 70; // px
    zenscroll.setup(defaultDuration, edgeOffset);
    window.addEventListener('scroll', () => determineActiveAnchor(containers), { passive: true });
  }, []);

  const determineActiveAnchor = containers => {
    let index = null;

    containers.forEach((container, i) => {
      if (!container) {
        return;
      }

      const { top } = container.getBoundingClientRect();
      if (top - 76 < 0) {
        index = i;
      }
    });

    setHighlightedIndex(index === null ? 0 : index);
  };

  const scrollTo = e => {
    e.preventDefault();
    const id = e.currentTarget.hash.substr(1);
    const element = document.getElementById(id);
    zenscroll.to(element);
  };

  return (
    <ul ref={ref}>
      {anchors.map((anchor, index) => {
        const active = index == highlightedIndex ? activeClass : null;
        return (
          <li key={anchor.label}>
            <a
              href={anchor.anchor}
              className={`whitespace-nowrap ${active}`}
              onClick={e => scrollTo(e)}>
              {anchor.icon}
              {anchor.label}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default PageNavigation;
